import React, { useState, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";
import { HOST, HOST_MEDIA_URL } from "../../host";
import { GlobalContext } from "../../../App";
import L from "leaflet";
import { logToServer } from "../../logger";
import { Modal } from "react-bootstrap";

function Conversion() {
  const [show, setShow] = useState(false);
  const { vis, Canvas, layerControls, userInfo, userProjects, organizationProjects, map, selTab, getCsrfToken } = useContext(GlobalContext);

  const [file, setFile] = useState(null);
  const [mess, setMess] = useState(null);
  const [color, setColor] = useState(null);
  const [fill, setFill] = useState(false);
  const [name, setName] = useState(null);
  const [id, setId] = useState(null);
  const [add, SetAdd] = useState(false);
  const [loader, setLoader] = useState(false);
  const [bounds, setBounds] = useState(null);
  const [aPro, setPro] = useState(false);
  const [pro, setSelPro] = useState("");
  const [path, setPath] = useState(null);
  const [type, setType] = useState(null);
  const [column, setColumn] = useState([]);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [csv, setCsv] = useState(false);
  const [file_path, setfile_path] = useState(null);
  const [parent, setParent] = useState(null);
  const [per, setPer] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [eventSource, setEventSource] = useState(null);

  const toolvisRef = useRef(null);
  const location = useLocation();

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    setMess(null);
    setBounds(null);
    SetAdd(false);
    setLoader(true);
    const CHUNK_SIZE = 50 * 1024 * 1024;

    if (!file) {
      alert("No file selected.");
      return;
    }

    let styleName = null;
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

    try {
      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        setPer(Math.round((chunkIndex / totalChunks) * 100));
        const start = chunkIndex * CHUNK_SIZE;
        const end = Math.min(file.size, start + CHUNK_SIZE);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append("chunk", chunk);
        formData.append("chunkIndex", chunkIndex);
        formData.append("totalChunks", totalChunks);
        formData.append("fileName", file.name);
        if (file.name.split(".").pop().toLowerCase() === "sld") {
          formData.append("name", styleName);
        }

        const response = await fetch(`${HOST}/convert`, {
          method: "POST",
          credentials: "include",
          headers: { "X-CSRFToken": await getCsrfToken() },
          body: formData,
        });

        if (response.ok) {
          const data = await response.json();
          if (data.lastChunk) {
            handleFinalResponse(data);
            setLoader(false);
          }
        } else {
          setMess("An error occurred while uploading the file.");
          setLoader(false);
          setPer(null);
          return;
        }
      }
    } catch (error) {
      logToServer("error", `Error uploading file: ${error}`);
      setMess("An error occurred while uploading the file.");
      setLoader(false);
      setPer(false);
    }
  };

  const handleFinalResponse = (data) => {
    if (data.zip_file) {
      const link = document.createElement("a");
      link.href = `${HOST_MEDIA_URL}/${data.zip_file}`;
      link.setAttribute("download", data.zip_file.split("/").pop());
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      setMess("No zip file was returned.");
    }
  };

  return (
    <div style={{ position: vis ? "absolute" : "relative" }} className="toolscont">
      {/* ── Trigger Button ── */}
      <button
        title="KML/GPX to SHP"
        className="btn text-white"
        id="upload"
        onClick={() => setShow((prev) => !prev)}
        style={{
          backgroundColor: "black",
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          border: "none",
          fontSize: "15px",
        }}
      >
        C
      </button>

      {show && (
        <div
          ref={toolvisRef}
          className="toolsvis"
          id="toolvis"
          style={{ display: "flex", flexDirection: "column", width: "220px", padding: "10px 12px" }}
        >
          {/* ── Header ── */}
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: "8px",
            marginBottom: "10px",
            borderBottom: "1px solid rgba(255,255,255,0.12)",
          }}>
            <span style={{ color: "#ccc", fontSize: "13px", fontWeight: 600 }}>
              <i className="fa-solid fa-arrows-rotate" style={{ marginRight: "6px", fontSize: "11px" }} />
              Conversion (kml to shp)
            </span>
            <span
              onClick={() => setShow(false)}
              style={{ color: "#e74c3c", fontSize: "20px", cursor: "pointer", lineHeight: 1 }}
            >
              &times;
            </span>
          </div>

          {/* ── Body ── */}
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>

            {/* File input row with info icon */}
            <div className="toolsvis-body">
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <input
                  className="form-control"
                  style={{ fontSize: "11px", color: "black", flex: 1, minWidth: 0, width: 0 }}
                  type="file"
                  accept=".kml,.gpx"
                  onChange={handleFileChange}
                />
                <i
                  className="fa fa-info-circle"
                  style={{ fontSize: "16px", color: "rgba(255,255,255,0.5)", cursor: "pointer", flexShrink: 0 }}
                  onClick={() => setShowModal((prev) => !prev)}
                  title="Upload .kml or .gpx files only"
                />
              </div>
            </div>

            {/* Info note (toggleable) */}
            {showModal && (
              <small style={{ color: "rgba(255,255,255,0.4)", fontSize: "10px" }}>
                Upload zipped shp / .geojson / .tif / .tiff / .geotiff / .kml / .kmz / .csv only
              </small>
            )}
            <button
              className="btn-add"
              style={{ width: "100%" }}
              onClick={handleUpload}
            >
              Upload Layer
            </button>

            {/* Progress */}
            {loader && (
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "2px" }}>
                <div className="lds-dual-ring" style={{ margin: 0 }}>
                  <i className="fa-solid fa-globe" />
                </div>
                {per != null && (
                  <small style={{ color: "#d3d3d3", fontSize: "11px" }}>
                    Progress: {per}%
                  </small>
                )}
              </div>
            )}

            {/* Error / status message */}
            {mess && (
              <small style={{ color: "#ff6b6b", fontSize: "11px" }}>{mess}</small>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Conversion;